var getColor = function getColor(color) {
  if (color === 'black') {
    return '--color-constant-01';
  }
  if (color === 'white') {
    return '--color-constant-02';
  }
  return "--color-text-".concat(color);
};
export var getTextColorVariable = function getTextColorVariable(color) {
  return "var(".concat(getColor(color), ")");
};